import { render, staticRenderFns } from "./print-drd.view.vue?vue&type=template&id=52b40106&"
import script from "./print-drd.view.vue?vue&type=script&lang=ts&"
export * from "./print-drd.view.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports